import gql from 'graphql-tag';
import { roleFields, basicMemberFields } from './GetMember';


export const storeBasicFields = `
  id
  type
  name
`;

const key = `GetStore`;
const query = gql`
query ${key} ($storeId: ID!, $memberNextToken: String, $limit: Int = 2, $excludeRole: ID) {
  getStore(
    id: $storeId
  ){
    ${storeBasicFields}
    members(nextToken: $memberNextToken, limit: $limit, filter:{memberRoleId:{ne:$excludeRole}}){
      nextToken
      items{
        ${basicMemberFields}
        role {
          ${roleFields}
        }
        manager{
          id
        }
        store{
          ${storeBasicFields}
        }
      }
    }
  }
}
`;

export const GET_STORE = { key, query };
